module.exports = __webpack_public_path__ + "static/Electronics2-ebbb21c19b0d10ab5e99933df98b78b4.png";